
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { IndexHeader } from "@/components/landing/IndexHeader";
import { HeroSection } from "@/components/landing/HeroSection";
import { HowItWorksSection } from "@/components/landing/HowItWorksSection";
import { BenefitsSection } from "@/components/landing/BenefitsSection";
import { TestimonialsSection } from "@/components/landing/TestimonialsSection";
import { VideoSection } from "@/components/landing/VideoSection";
import { CTASection } from "@/components/landing/CTASection";
import { MetricsSection } from "@/components/landing/MetricsSection";
import { IndexFooter } from "@/components/landing/IndexFooter";

const Index = () => {
  const navigate = useNavigate();
  const { user, session } = useAuth();

  // Redirect authenticated users to dashboard
  useEffect(() => {
    if (user && session) {
      navigate("/dashboard", { replace: true });
    }
  }, [user, session, navigate]);

  // Emergency fallback para callback Nuvemshop
  useEffect(() => {
    const search = window.location.search;
    const pathname = window.location.pathname;

    // Se estamos na home ("/") com parâmetros de callback da Nuvemshop
    if (pathname === '/' && search.includes('code=') && search.includes('state=')) {
      // Salvar parâmetros no localStorage como backup
      const urlParams = new URLSearchParams(search);
      const callbackParams = {
        code: urlParams.get('code'),
        state: urlParams.get('state'),
        store_id: urlParams.get('store_id'),
        timestamp: new Date().toISOString()
      };
      localStorage.setItem('nuvemshop_callback_params', JSON.stringify(callbackParams));

      // Tentar redirecionar
      const targetUrl = `/nuvemshop-callback${search}`;

      // Usar replace para evitar loop
      window.location.replace(targetUrl);
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <IndexHeader />
      
      <main className="container mx-auto px-4">
        <HeroSection />
        <CTASection />
        <MetricsSection />
        <HowItWorksSection />
        <BenefitsSection />
        <TestimonialsSection />
        <VideoSection />
      </main>

      <IndexFooter />
    </div>
  );
};

export default Index;
